<template>
<v-container>
  <v-card class="mx-auto" max-width="500px">
    <v-card-title centered>Login</v-card-title>
    <v-card-text>
      <v-text-field 
        label="Enter your email"
        v-model="email" data-cy="loginemail"></v-text-field>
      <v-text-field
        v-model="password"
        data-cy="loginpassword"
        name="name"
        label="Enter your password"
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="() => (showPass = !showPass)"
        :type="showPass ? 'text' : 'password'"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn data-cy="loginsubmit"
            @click.prevent="loginLocal"
            :disabled="isAppLoading">Submit</v-btn>
            <v-spacer></v-spacer>
            <router-link to="/register">
                  <a>Register</a>
                </router-link>
    </v-card-actions>
  </v-card>
</v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAppLoading"])
  },
  methods: {
    ...mapActions(["addMessage", "addErrorMessage", "clearMessage"]),
    loginLocal() {
      let user = {
        username: this.email,
        password: this.password,
        useCookie: true
      };
      this.login(user)
        .then(() => {
          this.clearMessage();
          //need to handle confirmed and reset.  Redirect to reset if reset flag is true and alert message to verify email if not confirmed
          const confirmed = this.currentUser.confirmed;
          const requirePwdReset = this.currentUser.requirePwdReset;
          if (!requirePwdReset && confirmed) {
            this.$router.push({
              name: "MyHome"
            });
          } else if(requirePwdReset && confirmed) {
            this.$router.push({
              name: "ResetPassword"
            });
          }
          else if(!confirmed){
            this.addErrorMessage('Your account is pending email verification, please check your email.');
          }
        })
        .catch(() => {
          let message_obj = {
            message: "Invalid Credentials",
            messageClass: "warning"
          };
          this.addMessage(message_obj);
        });
    },
    login(credential) {
      return new Promise((resolve, reject) => {
        this.$store.commit("auth_request");
        this.$axios
          .post("authenticate", credential, {
            headers: {
              "content-type": "application/json"
            }
          })
          .then(resp => {
            const token = resp.data.jwttoken;
            const user = {
              email: resp.data.email,
              firstName: resp.data.firstName,
              lastName: resp.data.lastName,
              uId: resp.data.uid,
              confirmed: resp.data.confirmed,
              roles: resp.data.roles
            };
            // const user = resp.data.user;
            localStorage.setItem("token", token);
            this.$axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${token}`;
            this.$store.dispatch("updateUserToken", {
              token: token,
              user: user
            });
            resolve(resp);
          })
          .catch(err => {
            this.$store.commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    }
  }
};
</script>

<style scoped>
.log-img {
  max-width: 100px;
  height: 80px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}

.l-btn {
  font-size: 0.9em;
}
</style>
